import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Select from "./Select";
import Header from "./Header";
import Footer from "./Footer";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <div>
        <Header />
        <Select />
      </div>
    ),
  },
  {
    path: "/:unite/:nombre",
    element: (
      <div>
        <Header />
        <App />
      </div>
    ),
  },
  {
    path: "*",
    element: (
      <div>
        <Header />
        <p>Il n'y a rien ici !</p>
      </div>
    ),
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
    <Footer />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
